// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyACjxmhtN3j4SoCfp0U0vA_hGn-aZSv19Y",
  authDomain: "iclicker-web-c0d76.firebaseapp.com",
  databaseURL: "https://iclicker-web-c0d76.firebaseio.com",
  projectId: "iclicker-web-c0d76",
  storageBucket: "iclicker-web-c0d76.appspot.com",
  messagingSenderId: "134399078405",
  appId: "1:134399078405:web:bca23025c39466321cac6c",
  measurementId: "G-YEXH8FPX88",
};
